import { SvgIcon } from '@mui/material'
import { ReactComponent as MyIcon } from './Vector.svg'

const VectorIcon = props => {
    return <SvgIcon component={MyIcon} {...props} />
}

export default VectorIcon
